import "./proposed-household-table.scss";
import { HTMLProps, useMemo } from 'react'
import { HoldingTypeEnum } from "../../../../../models/enum/holding-type.enum";
import { HoldingTypeTypeCode } from "../../../../../utils/code-converter";
import { useAppSelector } from "../../../../../redux/hook";

interface ProposedHouseholdTableInterface extends HTMLProps<HTMLDivElement> {

}

const ProposedHouseholdTable = ({ ...props }: ProposedHouseholdTableInterface) => {
  const applicationStep3 = useAppSelector(state => state.app.ApplicationStep3Slice.formData);

  const proposedHoldingType = useMemo(() => {
    return HoldingTypeTypeCode.find(e => e.code === applicationStep3.holding_type)?.description;
  }, [])


  const toShowSharedTable = useMemo((): boolean => {
    return applicationStep3.tenancy_in_common.length > 0 && applicationStep3.holding_type === HoldingTypeEnum.tenancy_in_common;
  }, [])


  return (
    <div className='solicitor-proposed-household'>
      <div className='solicitor-proposed-household-content'>
        <p>{proposedHoldingType}</p>
      </div>

      {toShowSharedTable && <div {...props}>
        <div>
          <div className="solicitor-proposed-household-table">
            <div className="solicitor-proposed-household-table__header_row header">Owners</div>
            <div className="solicitor-proposed-household-table__header_row header">Shares</div>

            {applicationStep3.tenancy_in_common.map((item, _index) => {

              return (
                <>
                  <div className={`solicitor-proposed-household-table__row ${_index === applicationStep3.tenancy_in_common.length - 1 ? 'solicitor-proposed-household-table__row_last' : ''}`}>{item.user.myinfo.name}</div>
                  <div className={`solicitor-proposed-household-table__row ${_index === applicationStep3.tenancy_in_common.length - 1 ? 'solicitor-proposed-household-table__row_last' : ''}`}>{item.shares}</div>
                </>
              )

            })}
          </div>
        </div>
      </div>}
    </div>
  )
}

export default ProposedHouseholdTable